export const settings = {
  setShareTitle: 'Udostępnij aplikację',
  setNotifiationsTitle: 'Powiadomienia',
  setContactAppOwnerTitle: 'Skontaktuj się z właścicielem aplikacji',
  setContactDevelopersTitle: 'Skontaktuj się z deweloperami',
  setReportAppTitle: 'Zgłoś aplikację',
  setDeleteAccountTitle: 'Usuń konto',
  setLogOutTitle: 'Wyloguj',
  setShareAppCurtainTitle: 'Udostępnij aplikację',
  setShareAppCurtainButtonTitle: 'Kopiuj link',
  setShareAppAlertWhenAppLinkWasCopied: 'Link skopiowany!',
  setNotificationsInAppTitle: 'W aplikacji',
  setNotificationsPushContent: 'Powiadomienia push',
  setNotificationsChatsTitle: 'Czaty',
  setNotificationsDiscussionsTitle: 'Dyskusje',
  setNotificationsNewsTitle: 'Aktualności',
  setNotificationsEventsTitle: 'Wydarzenia',
  setNotificationsAdminTitle: 'Wiadomości od admina',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'Powiadomienia push są wyłączone',
  setNotificationsPushOffText: 'Aby je włączyć, przejdź do ustawień urządzenia i włącz powiadomienia',
  setReportAppFlagCurtainTitle: 'Zgłoś',
  setAppReportedCurtainContent: 'Zawartość zgłoszona',
  setDeleteCurtainTitle: 'Usuń konto',
  setDeleteCurtainInputContent: 'Hasło',
  setDeleteCurtainCancelButtonTitle: 'Anuluj',
  setDeleteCurtainConfirmButtonTitle: 'Potwierdź',
  setDeleteCurtainIncorrectPasswordAlertText: 'Nieprawidłowe hasło',
  setTurnNotificationsOnText: 'Aby je włączyć, kliknij poniższy przycisk i zezwól na otrzymywanie powiadomień.',
  setTurnNotificationsOnButton: 'Włącz powiadomienia push',
  changeLanguage: 'Zmień język aplikacji',
  changeLanguageAlertSuccess: 'Język aplikacji został pomyślnie zmieniony'
}
